/* ═══════════════════════════════════════════════
   Caneko — animations & interactions
   ═══════════════════════════════════════════════ */

(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var HAS_GSAP = typeof window.gsap !== "undefined" && typeof window.ScrollTrigger !== "undefined";

  if (REDUCED) document.documentElement.classList.add("reduced-motion");
  if (!HAS_GSAP) document.documentElement.classList.add("no-gsap");

  /* ──────────────────────────────────────────────
     1. La brosse en SVG (construite en code,
        réutilisée : héro, section, achat, curseur)
     ────────────────────────────────────────────── */
  var brushCount = 0;

  function buildBrush(container, opts) {
    if (!container) return;
    opts = opts || {};
    var id = "b" + (++brushCount);
    var withMist = opts.mist !== false;

    // ── coussin orange : décalé à gauche, le peigne occupe le flanc droit ──
    var padCx = 136, padCy = 250, padHW = 90, padHH = 208, padRR = 78;
    var bHW = padHW - 14, bHH = padHH - 14, bRR = padRR - 14;

    function inPad(dx, dy) {
      var ax = Math.abs(dx), ay = Math.abs(dy);
      if (ax > bHW || ay > bHH) return false;
      var ix = bHW - bRR, iy = bHH - bRR;
      if (ax <= ix || ay <= iy) return true;
      var ox = ax - ix, oy = ay - iy;
      return ox * ox + oy * oy <= bRR * bRR;
    }

    var picots = "";
    var stepX = 16, stepY = 17.5;
    var rows = Math.floor((2 * bHH) / stepY);
    for (var r = 0; r <= rows; r++) {
      var dy = -bHH + r * stepY;
      var shift = (r % 2) ? stepX / 2 : 0;
      for (var dx = -bHW + shift - stepX; dx <= bHW + stepX; dx += stepX) {
        if (!inPad(dx, dy)) continue;
        if (dx * dx + dy * dy < 36 * 36) continue;    // dégage la buse vapeur
        var tilt = (dx / bHW) * 16 + (dy / bHH) * 3;  // les picots s'évasent
        var sc = (0.88 + 0.18 * Math.abs(dx) / bHW).toFixed(2);
        picots +=
          '<g transform="translate(' + (padCx + dx).toFixed(1) + "," + (padCy + dy).toFixed(1) +
          ") rotate(" + tilt.toFixed(1) + ") scale(" + sc + ')">' +
          '<path d="M0,-11.5 C2.4,-7.2 3.9,1 2.7,8.8 L-2.7,8.8 C-3.9,1 -2.4,-7.2 0,-11.5 Z" fill="url(#pic-' + id + ')"/>' +
          '<path d="M-1,-7.6 C-2,-3.2 -2.2,1.6 -1.8,6.4" stroke="rgba(255,255,255,.42)" stroke-width="1.2" fill="none" stroke-linecap="round"/>' +
          "</g>";
      }
    }

    // peigne rainuré crème sur le flanc droit
    var peigne = "";
    for (var sy = 106; sy <= 394; sy += 13) {
      peigne += '<path d="M243 ' + sy + ' h32"/>';
    }

    var mist = "";
    if (withMist) {
      mist =
        '<g filter="url(#blur-' + id + ')">' +
        '<circle class="mist" cx="136" cy="232" r="15" fill="rgba(255,255,255,.8)"/>' +
        '<circle class="mist mist--2" cx="147" cy="226" r="11" fill="rgba(255,255,255,.7)"/>' +
        '<circle class="mist mist--3" cx="125" cy="224" r="13" fill="rgba(255,255,255,.75)"/>' +
        "</g>";
    }

    container.innerHTML =
      '<svg class="brush-svg" viewBox="0 0 320 800" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Brosse vapeur Caneko">' +
      "<defs>" +
      '<linearGradient id="body-' + id + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#FBF7EE"/><stop offset=".38" stop-color="#EDE4D4"/>' +
      '<stop offset=".74" stop-color="#DACFB9"/><stop offset="1" stop-color="#C2B69E"/></linearGradient>' +
      '<linearGradient id="handle-' + id + '" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#EFE7D8"/><stop offset=".45" stop-color="#E2D8C4"/>' +
      '<stop offset="1" stop-color="#CBBFA6"/></linearGradient>' +
      '<linearGradient id="pad-' + id + '" x1=".15" y1="0" x2=".9" y2="1">' +
      '<stop offset="0" stop-color="#F79B3E"/><stop offset=".55" stop-color="#F0821F"/>' +
      '<stop offset="1" stop-color="#D96C12"/></linearGradient>' +
      '<linearGradient id="pic-' + id + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#FFC078"/><stop offset=".5" stop-color="#F79338"/>' +
      '<stop offset="1" stop-color="#CE6910"/></linearGradient>' +
      '<radialGradient id="hole-' + id + '" cx=".38" cy=".32" r=".9">' +
      '<stop offset="0" stop-color="#B9BDC2"/><stop offset=".55" stop-color="#6C7075"/>' +
      '<stop offset="1" stop-color="#2E3135"/></radialGradient>' +
      '<filter id="blur-' + id + '" x="-80%" y="-80%" width="260%" height="260%">' +
      '<feGaussianBlur stdDeviation="6"/></filter>' +
      "</defs>" +
      // ── pièces séparées : la vue éclatée anime chaque groupe ──
      // poignée : tige ronde pliée en U
      '<g class="pz pz-handle">' +
      '<g fill="none" stroke-linecap="round">' +
      '<path d="M127,505 L127,730 A33,33 0 0 0 193,730 L193,505" stroke="#AC9F86" stroke-width="27"/>' +
      '<path d="M127,505 L127,730 A33,33 0 0 0 193,730 L193,505" stroke="url(#handle-' + id + ')" stroke-width="23.5"/>' +
      '<path d="M120,545 L120,690" stroke="rgba(255,255,255,.5)" stroke-width="5.5"/>' +
      '<path d="M186,545 L186,690" stroke="rgba(255,255,255,.34)" stroke-width="5.5"/>' +
      "</g></g>" +
      // corps : capsule beige, peigne, port USB-C
      '<g class="pz pz-body">' +
      '<rect x="30" y="15" width="260" height="470" rx="130" fill="url(#body-' + id + ')" stroke="#B8AC93" stroke-width="1.6"/>' +
      '<rect x="40" y="25" width="240" height="450" rx="120" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="2.4"/>' +
      '<ellipse cx="88" cy="112" rx="24" ry="54" fill="rgba(255,255,255,.26)" transform="rotate(-18 88 112)"/>' +
      '<rect x="236" y="88" width="46" height="324" rx="23" fill="#E6DCC8" stroke="#C0B399" stroke-width="1.4"/>' +
      '<g stroke="#B2A489" stroke-width="3.4" stroke-linecap="round" opacity=".6">' + peigne + "</g>" +
      '<rect x="33" y="188" width="8" height="32" rx="4" fill="#A2957B" opacity=".7"/>' +
      "</g>" +
      // coussin orange et ses picots
      '<g class="pz pz-pad" style="filter: drop-shadow(0 16px 20px rgba(34,27,19,.14))">' +
      '<rect x="44" y="40" width="184" height="420" rx="80" fill="rgba(105,70,25,.25)"/>' +
      '<rect x="46" y="42" width="180" height="416" rx="78" fill="url(#pad-' + id + ')"/>' +
      picots +
      "</g>" +
      // buse vapeur
      '<g class="pz pz-nozzle" style="filter: drop-shadow(0 12px 16px rgba(34,27,19,.16))">' +
      '<circle cx="136" cy="250" r="26" fill="#EDE4D2" stroke="#C3B69B" stroke-width="2"/>' +
      '<circle cx="136" cy="250" r="13" fill="url(#hole-' + id + ')"/>' +
      '<circle cx="132" cy="245" r="3.4" fill="rgba(255,255,255,.45)"/>' +
      mist +
      "</g>" +
      // molette 360° (voyage avec la poignée)
      '<g class="pz pz-molette">' +
      '<circle cx="160" cy="492" r="31" fill="url(#handle-' + id + ')" stroke="#AC9F86" stroke-width="1.8"/>' +
      '<circle cx="160" cy="492" r="22" fill="none" stroke="rgba(255,255,255,.45)" stroke-width="3"/>' +
      '<circle cx="160" cy="492" r="13" fill="none" stroke="rgba(150,135,105,.32)" stroke-width="2.4"/>' +
      "</g>" +
      "</svg>";
  }

  /* ──────────────────────────────────────────────
     1 bis. La face ARRIÈRE — c'est ce qu'on voit
     quand on tient la brosse et qu'on brosse l'animal
     ────────────────────────────────────────────── */
  function buildBrushBack(container) {
    if (!container) return;
    var id = "bk" + (++brushCount);

    // demi-largeur du corps à une hauteur donnée (capsule)
    function halfW(y) {
      if (y >= 145 && y <= 355) return 130;
      var dy = y < 145 ? 145 - y : y - 355;
      var v = 130 * 130 - dy * dy;
      return v > 0 ? Math.sqrt(v) : 0;
    }

    // pointes qui dépassent de la silhouette : de dos, le peigne passe
    // à droite et les picots orange à gauche (l'appareil est retourné)
    var tips = "";
    for (var ty = 66; ty <= 434; ty += 21) {
      var hw = halfW(ty);
      if (hw < 46) continue;
      var len = (11 + 9 * (hw / 130)).toFixed(1);
      tips +=
        '<path d="M' + (160 - hw + 4).toFixed(1) + "," + ty + " h-" + len +
        '" stroke="#EE9128" stroke-width="8" stroke-linecap="round"/>' +
        '<path d="M' + (160 + hw - 4).toFixed(1) + "," + ty + " h" + len +
        '" stroke="#D9CDB5" stroke-width="7" stroke-linecap="round"/>';
    }

    container.innerHTML =
      '<svg class="brush-svg" viewBox="0 0 320 800" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Brosse vapeur Caneko, face arrière">' +
      "<defs>" +
      '<linearGradient id="body-' + id + '" x1="0" y1="0" x2="1" y2="1">' +
      '<stop offset="0" stop-color="#FCF9F1"/><stop offset=".4" stop-color="#F0E8D9"/>' +
      '<stop offset=".75" stop-color="#DED4BF"/><stop offset="1" stop-color="#C6BAA2"/></linearGradient>' +
      '<linearGradient id="handle-' + id + '" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#EFE7D8"/><stop offset=".45" stop-color="#E2D8C4"/>' +
      '<stop offset="1" stop-color="#CBBFA6"/></linearGradient>' +
      '<linearGradient id="btn-' + id + '" x1="0" y1="0" x2="0" y2="1">' +
      '<stop offset="0" stop-color="#DACCAC"/><stop offset="1" stop-color="#BBA783"/></linearGradient>' +
      "</defs>" +
      // poignée en U
      '<g fill="none" stroke-linecap="round">' +
      '<path d="M127,505 L127,730 A33,33 0 0 0 193,730 L193,505" stroke="#AC9F86" stroke-width="27"/>' +
      '<path d="M127,505 L127,730 A33,33 0 0 0 193,730 L193,505" stroke="url(#handle-' + id + ')" stroke-width="23.5"/>' +
      '<path d="M120,545 L120,690" stroke="rgba(255,255,255,.5)" stroke-width="5.5"/>' +
      '<path d="M186,545 L186,690" stroke="rgba(255,255,255,.34)" stroke-width="5.5"/>' +
      "</g>" +
      tips +
      // corps vu de dos
      '<rect x="30" y="15" width="260" height="470" rx="130" fill="url(#body-' + id + ')" stroke="#B8AC93" stroke-width="1.6"/>' +
      '<rect x="40" y="25" width="240" height="450" rx="120" fill="none" stroke="rgba(255,255,255,.55)" stroke-width="2.4"/>' +
      // logement ovale en creux + bouton vapeur
      '<ellipse cx="160" cy="190" rx="76" ry="56" fill="rgba(120,104,74,.16)"/>' +
      '<ellipse cx="160" cy="187" rx="72" ry="52" fill="#EDE5D3" stroke="#C6B99E" stroke-width="1.4"/>' +
      '<ellipse cx="160" cy="187" rx="52" ry="36" fill="url(#btn-' + id + ')" stroke="#AB9873" stroke-width="1.4"/>' +
      '<path d="M160,170 C168,182 172,190 172,196 a12,12 0 0 1 -24,0 c0,-6 4,-14 12,-26 Z" fill="rgba(255,255,255,.55)"/>' +
      // témoin
      '<circle cx="160" cy="277" r="15" fill="#E7DECB" stroke="#C6B99E" stroke-width="1.4"/>' +
      '<circle cx="160" cy="277" r="7" fill="rgba(160,140,105,.32)"/>' +
      // molette 360°
      '<circle cx="160" cy="492" r="31" fill="url(#handle-' + id + ')" stroke="#AC9F86" stroke-width="1.8"/>' +
      '<circle cx="160" cy="492" r="22" fill="none" stroke="rgba(255,255,255,.45)" stroke-width="3"/>' +
      '<circle cx="160" cy="492" r="13" fill="none" stroke="rgba(150,135,105,.32)" stroke-width="2.4"/>' +
      // reflet
      '<ellipse cx="88" cy="105" rx="24" ry="52" fill="rgba(255,255,255,.3)" transform="rotate(-18 88 105)"/>' +
      "</svg>";
  }

  buildBrush(document.getElementById("buyBrush"));
  buildBrushBack(document.getElementById("brushCursor"));

  /* ──────────────────────────────────────────────
     2. En-tête : fond + bouton d'achat au défilement
     ────────────────────────────────────────────── */
  var header = document.getElementById("header");
  var headerCta = document.getElementById("headerCta");

  function onScrollHeader() {
    header.classList.toggle("is-solid", window.scrollY > 40);
  }
  window.addEventListener("scroll", onScrollHeader, { passive: true });
  onScrollHeader();

  /* ──────────────────────────────────────────────
     3. Animations GSAP (héro, apparitions, rotation)
     ────────────────────────────────────────────── */
  if (HAS_GSAP && !REDUCED) {
    gsap.registerPlugin(ScrollTrigger);

    // rotation du téléphone : la géométrie de la section épinglée change
    window.addEventListener("orientationchange", function () {
      setTimeout(function () { ScrollTrigger.refresh(); }, 350);
    });

    // apparitions au défilement
    gsap.utils.toArray(".reveal-up").forEach(function (el) {
      gsap.from(el, {
        y: 40, opacity: 0, duration: 0.9, ease: "power3.out",
        scrollTrigger: { trigger: el, start: "top 86%" }
      });
    });




  }

  /* ──────────────────────────────────────────────
     4. Compteurs animés (84 · 360 · 3)
     ────────────────────────────────────────────── */
  var counters = document.querySelectorAll(".stats__num[data-count]");
  var counterIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      counterIO.unobserve(entry.target);
      var el = entry.target;
      var target = parseInt(el.getAttribute("data-count"), 10);
      if (REDUCED) { el.textContent = target; return; }
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 1400, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.6 });
  counters.forEach(function (el) { counterIO.observe(el); });

  /* ──────────────────────────────────────────────
     5. Vapeur : particules sur canvas
     ────────────────────────────────────────────── */
  (function steam() {
    var canvas = document.getElementById("steamCanvas");
    if (!canvas || REDUCED) return;
    var ctx = canvas.getContext("2d");
    var particles = [], running = false, W = 0, H = 0;

    function resize() {
      W = canvas.width = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    }
    resize();
    window.addEventListener("resize", resize);

    function spawn() {
      particles.push({
        x: W / 2 + (Math.random() - 0.5) * W * 0.5,
        y: H * (0.85 + Math.random() * 0.15),
        vx: (Math.random() - 0.5) * 0.3,
        vy: -(0.5 + Math.random() * 0.7),
        r: 24 + Math.random() * 60,
        life: 0,
        max: 260 + Math.random() * 200
      });
    }

    function tick() {
      if (!running) return;
      ctx.clearRect(0, 0, W, H);
      if (particles.length < 46 && Math.random() < 0.5) spawn();
      for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.life++;
        p.x += p.vx + Math.sin(p.life * 0.02) * 0.35;
        p.y += p.vy;
        p.r += 0.14;
        var fade = Math.sin(Math.min(p.life / p.max, 1) * Math.PI);
        if (p.life >= p.max || p.y < -p.r) { particles.splice(i, 1); continue; }
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
        g.addColorStop(0, "rgba(250,246,239," + (0.07 * fade).toFixed(3) + ")");
        g.addColorStop(1, "rgba(250,246,239,0)");
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fill();
      }
      requestAnimationFrame(tick);
    }

    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      if (visible && !running) { running = true; tick(); }
      else if (!visible) { running = false; }
    }, { threshold: 0.05 }).observe(canvas.parentElement);
  })();

  /* ──────────────────────────────────────────────
     6. « Brossez Kiwi » — le chat photoréaliste
        Deux photos alignées : pelage hérissé de
        poils morts (dessus) → pelage lisse (dessous).
        La brosse efface la couche du dessus.
     ────────────────────────────────────────────── */
  (function catGame() {
    var scene = document.getElementById("tryScene");
    var zone = document.getElementById("tryZone") || scene;
    var base = document.getElementById("catBase");
    var fuzz = document.getElementById("catFuzz");
    var fx = document.getElementById("catFx");
    if (!scene || !base) return;

    var DPR = Math.min(window.devicePixelRatio || 1, 2);
    var LW = 680, LH = 548; // taille logique (photos 1152×928)

    [base, fuzz, fx].forEach(function (c) {
      c.width = LW * DPR; c.height = LH * DPR;
      c.getContext("2d").scale(DPR, DPR);
    });

    var bctx = base.getContext("2d");
    var fctx = fuzz.getContext("2d");
    var xctx = fx.getContext("2d");

    // poils qui s'envolent : mêmes teintes que le pelage roux/crème
    var hairColors = ["#D89050", "#C67B3B", "#F0DCC2", "#A86A2E"];

    /* — grille de progression (remplie après analyse des photos) — */
    var CELL = 24;
    var COLS = Math.ceil(LW / CELL), ROWS = Math.ceil(LH / CELL);
    var furry = [], erased = [], totalFurry = 0;
    var ready = false;

    /* — chargement des deux photos — */
    var imgClean = new Image();
    var imgMessy = new Image();
    var loaded = 0;

    function onLoad() {
      if (++loaded < 2) return;
      bctx.drawImage(imgClean, 0, 0, LW, LH);
      fctx.drawImage(imgMessy, 0, 0, LW, LH);
      analyse();
      ready = true;
    }
    imgClean.onload = onLoad;
    imgMessy.onload = onLoad;
    imgClean.onerror = imgMessy.onerror = function () {
      hint.textContent = "Le jeu n'a pas pu charger. Rechargez la page pour essayer de brosser Kiwi.";
      var prog = document.querySelector(".try__progress");
      if (prog) prog.style.display = "none";
    };
    // sur Shopify les images viennent du CDN : sans ça le canvas est
    // « teinté » et l'analyse des poils devient impossible
    imgClean.crossOrigin = "anonymous";
    imgMessy.crossOrigin = "anonymous";
    imgClean.src = scene.dataset.clean || "images/cat-clean.jpg";
    imgMessy.src = scene.dataset.messy || "images/cat-messy.jpg";

    /* — repère les zones où les deux photos diffèrent :
         ce sont les poils morts à retirer — */
    function analyse() {
      var dClean, dMessy;
      try {
        dClean = bctx.getImageData(0, 0, LW * DPR, LH * DPR).data;
        dMessy = fctx.getImageData(0, 0, LW * DPR, LH * DPR).data;
      } catch (err) {
        // page ouverte sans serveur (file://) : on prend une zone
        // ovale au centre, là où se trouve le chat
        for (var fr = 0; fr < ROWS; fr++) {
          for (var fc = 0; fc < COLS; fc++) {
            var ex = (fc + 0.5) / COLS - 0.5, ey = (fr + 0.5) / ROWS - 0.55;
            var isIn = (ex * ex) / 0.11 + (ey * ey) / 0.14 < 1;
            furry.push(isIn);
            erased.push(false);
            if (isIn) totalFurry++;
          }
        }
        return;
      }
      var stride = LW * DPR * 4;

      for (var r = 0; r < ROWS; r++) {
        for (var c = 0; c < COLS; c++) {
          // moyenne de la différence sur 9 points de la cellule
          var diff = 0, samples = 0;
          for (var sy = 0; sy < 3; sy++) {
            for (var sx = 0; sx < 3; sx++) {
              var px = Math.min(LW - 1, (c + 0.25 + sx * 0.25) * CELL) * DPR | 0;
              var py = Math.min(LH - 1, (r + 0.25 + sy * 0.25) * CELL) * DPR | 0;
              var i = py * stride + px * 4;
              diff += Math.abs(dClean[i] - dMessy[i]) +
                      Math.abs(dClean[i + 1] - dMessy[i + 1]) +
                      Math.abs(dClean[i + 2] - dMessy[i + 2]);
              samples++;
            }
          }
          var isFurry = (diff / samples) > 14; // seuil : vraie différence de pelage
          furry.push(isFurry);
          erased.push(false);
          if (isFurry) totalFurry++;
        }
      }
    }

    /* — effacement au passage de la brosse — */
    var fill = document.getElementById("tryFill");
    var label = document.getElementById("tryLabel");
    var hint = document.getElementById("tryHint");
    var badge = document.getElementById("tryBadge");
    var done = false;
    var erasedCount = 0;
    var lastPt = null;
    // au doigt la précision est moindre : brosse plus large
    var COARSE = window.matchMedia("(pointer: coarse)").matches;
    var RADIUS = COARSE ? 50 : 36;

    function stamp(x, y) {
      var g = fctx.createRadialGradient(x, y, 0, x, y, RADIUS);
      g.addColorStop(0, "rgba(0,0,0,1)");
      g.addColorStop(0.7, "rgba(0,0,0,.85)");
      g.addColorStop(1, "rgba(0,0,0,0)");
      fctx.globalCompositeOperation = "destination-out";
      fctx.fillStyle = g;
      fctx.beginPath();
      fctx.arc(x, y, RADIUS, 0, Math.PI * 2);
      fctx.fill();
      fctx.globalCompositeOperation = "source-over";

      // cellules touchées
      var c0 = Math.max(0, Math.floor((x - RADIUS) / CELL));
      var c1 = Math.min(COLS - 1, Math.floor((x + RADIUS) / CELL));
      var r0 = Math.max(0, Math.floor((y - RADIUS) / CELL));
      var r1 = Math.min(ROWS - 1, Math.floor((y + RADIUS) / CELL));
      for (var rr = r0; rr <= r1; rr++) {
        for (var cc = c0; cc <= c1; cc++) {
          var i = rr * COLS + cc;
          if (furry[i] && !erased[i]) {
            var dx = (cc + 0.5) * CELL - x, dy = (rr + 0.5) * CELL - y;
            if (dx * dx + dy * dy < RADIUS * RADIUS) {
              erased[i] = true;
              erasedCount++;
            }
          }
        }
      }
    }

    function updateProgress() {
      var p = totalFurry ? erasedCount / totalFurry : 0;
      var pct = Math.min(100, Math.round(p * 143)); // 70 % des zones = 100 % affiché
      fill.style.width = pct + "%";
      label.textContent = "Poils retirés : " + pct + " %";
      if (pct >= 100 && !done) complete();
    }

    function complete() {
      done = true;
      fuzz.classList.add("is-clean");
      badge.classList.add("is-visible");
      hint.classList.add("is-done");
      hint.textContent = "Kiwi est tout doux. Imaginez sur votre boule de poils.";
      label.textContent = "Poils retirés : 100 %";
      burst(LW / 2, LH * 0.42);
      // le moment de désir maximal débouche sur l'achat
      var cta = document.getElementById("tryCta");
      if (cta) cta.classList.add("is-visible");
    }

    /* — particules : poils qui s'envolent + éclat final — */
    var fxParticles = [], fxRunning = false;

    function fxTick() {
      if (!fxParticles.length) { fxRunning = false; xctx.clearRect(0, 0, LW, LH); return; }
      xctx.clearRect(0, 0, LW, LH);
      for (var i = fxParticles.length - 1; i >= 0; i--) {
        var p = fxParticles[i];
        p.life++;
        p.x += p.vx; p.y += p.vy;
        p.vy += p.grav; p.rot += p.vr;
        var a = 1 - p.life / p.max;
        if (a <= 0) { fxParticles.splice(i, 1); continue; }
        xctx.save();
        xctx.translate(p.x, p.y);
        xctx.rotate(p.rot);
        xctx.globalAlpha = a;
        if (p.kind === "hair") {
          xctx.strokeStyle = p.color;
          xctx.lineWidth = 1.6;
          xctx.lineCap = "round";
          xctx.beginPath();
          xctx.moveTo(-p.size, 0);
          xctx.quadraticCurveTo(0, -3, p.size, 0);
          xctx.stroke();
        } else {
          xctx.fillStyle = p.color;
          xctx.beginPath();
          xctx.arc(0, 0, p.size, 0, Math.PI * 2);
          xctx.fill();
        }
        xctx.restore();
      }
      requestAnimationFrame(fxTick);
    }

    function spawnHairs(x, y, n) {
      for (var i = 0; i < n; i++) {
        fxParticles.push({
          kind: "hair",
          x: x + (Math.random() - 0.5) * 20,
          y: y + (Math.random() - 0.5) * 20,
          vx: (Math.random() - 0.5) * 2.4,
          vy: -1.6 - Math.random() * 1.6,
          grav: 0.07,
          rot: Math.random() * Math.PI,
          vr: (Math.random() - 0.5) * 0.2,
          size: 5 + Math.random() * 6,
          color: hairColors[(Math.random() * hairColors.length) | 0],
          life: 0,
          max: 60 + Math.random() * 40
        });
      }
      if (!fxRunning) { fxRunning = true; fxTick(); }
    }

    function burst(x, y) {
      for (var i = 0; i < 46; i++) {
        var ang = Math.random() * Math.PI * 2;
        var sp = 2 + Math.random() * 5;
        fxParticles.push({
          kind: "spark",
          x: x, y: y,
          vx: Math.cos(ang) * sp,
          vy: Math.sin(ang) * sp - 1,
          grav: 0.05,
          rot: 0, vr: 0,
          size: 2 + Math.random() * 3.5,
          color: Math.random() < 0.5 ? "#F49D37" : "#FBDDB4",
          life: 0,
          max: 50 + Math.random() * 40
        });
      }
      if (!fxRunning) { fxRunning = true; fxTick(); }
    }

    /* — pointeur / curseur-brosse — */
    var cursor = document.getElementById("brushCursor");
    var moveCount = 0;
    // souris = on affiche la brosse ; doigt = on la masque
    var FINE_POINTER = window.matchMedia("(hover: hover) and (pointer: fine)").matches;

    // au doigt, la consigne parle de doigt — pas de curseur
    if (!FINE_POINTER && hint) {
      hint.textContent = "Frottez son pelage avec votre doigt, la brosse fait le reste.";
    }

    function toLocal(e) {
      var rect = scene.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width * LW;
      var y = (e.clientY - rect.top) / rect.height * LH;
      // un doigt posé dans la marge est ramené au bord du pelage
      return {
        x: Math.max(0, Math.min(LW, x)),
        y: Math.max(0, Math.min(LH, y))
      };
    }

    zone.addEventListener("pointerenter", function () {
      if (FINE_POINTER) cursor.classList.add("is-active");
    });
    var lastClient = null;

    function hideCursor() {
      cursor.classList.remove("is-active");
      lastPt = null;
    }

    zone.addEventListener("pointerleave", function () {
      hideCursor();
      lastClient = null;
    });
    document.addEventListener("pointerleave", hideCursor);

    var fingerDown = false;

    // en défilant à la molette la souris ne bouge pas : on vérifie nous-mêmes
    // si le chat est encore sous le pointeur, sinon la brosse resterait collée
    window.addEventListener("scroll", function () {
      // le défilement déplace le chat sous le pointeur : on interrompt le
      // trait en cours pour ne pas tracer une traînée fantôme.
      // Sauf si un doigt est posé : là c'est un vrai geste de brossage.
      if (!fingerDown) lastPt = null;
      if (!lastClient) return;
      var r = scene.getBoundingClientRect();
      var dedans = lastClient.x >= r.left && lastClient.x <= r.right &&
                   lastClient.y >= r.top && lastClient.y <= r.bottom;
      if (!dedans) hideCursor();
    }, { passive: true });

    // au doigt, on lit l'intention : frotter = brosser (page immobile),
    // glissement franchement vertical = on fait défiler la page nous-mêmes
    var touchMode = null;      // null | "pending" | "brush" | "scroll"
    var touchStart = null;
    var lastClientY = 0;

    zone.addEventListener("pointerdown", function (e) {
      cursor.classList.add("is-pressing");
      fingerDown = true;
      // on garde la main sur le geste même si le doigt glisse vite
      if (zone.setPointerCapture) {
        try { zone.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (e.pointerType === "touch") {
        touchMode = "brush";
        // retour immédiat : poser le doigt brosse déjà
        if (ready && !done) {
          var tpt = toLocal(e);
          stamp(tpt.x, tpt.y);
          lastPt = tpt;
          spawnHairs(tpt.x, tpt.y, 3);
          updateProgress();
        }
        cursor.style.transform = "translate(" + (e.clientX - 24) + "px," + (e.clientY - 92) + "px) rotate(14deg)";
        cursor.classList.add("is-active");
        return;
      }
      // à la souris, le clic brosse immédiatement
      if (ready && !done) {
        var pt = toLocal(e);
        stamp(pt.x, pt.y);
        lastPt = pt;
        spawnHairs(pt.x, pt.y, 3);
        updateProgress();
      }
    });

    function endStroke(e) {
      cursor.classList.remove("is-pressing");
      // après un geste au doigt, la brosse disparaît en levant le doigt
      if (touchMode || !FINE_POINTER || (e && e.pointerType === "touch")) {
        cursor.classList.remove("is-active");
      }
      fingerDown = false;
      lastPt = null;
      touchMode = null;
      touchStart = null;
    }
    window.addEventListener("pointerup", endStroke);
    window.addEventListener("pointercancel", endStroke);

    function brosse(e) {
      if (done || !ready) return;
      var pt = toLocal(e);
      if (lastPt) {
        var dx = pt.x - lastPt.x, dy = pt.y - lastPt.y;
        var dist = Math.sqrt(dx * dx + dy * dy);
        var steps = Math.max(1, Math.floor(dist / 14));
        for (var i = 1; i <= steps; i++) {
          stamp(lastPt.x + dx * i / steps, lastPt.y + dy * i / steps);
        }
        if (++moveCount % 3 === 0 && dist > 4) spawnHairs(pt.x, pt.y, 2);
      } else {
        stamp(pt.x, pt.y);
      }
      lastPt = pt;
      updateProgress();
    }

    zone.addEventListener("pointermove", function (e) {

      /* ── doigt ── */
      if (e.pointerType === "touch") {
        if (!fingerDown) return;

        // sur le chat, le doigt ne fait QUE brosser : la page ne bouge
        // jamais ici ; on défile depuis le reste de l'écran
        cursor.style.transform = "translate(" + (e.clientX - 24) + "px," + (e.clientY - 92) + "px) rotate(14deg)";
        cursor.classList.add("is-active");
        brosse(e);
        return;
      }

      /* ── souris ── */
      // le navigateur renvoie de faux mouvements quand la page défile sous
      // un pointeur immobile : même position à l'écran = on ne brosse pas
      var immobile = lastClient &&
        Math.abs(e.clientX - lastClient.x) < 2 &&
        Math.abs(e.clientY - lastClient.y) < 2;
      lastClient = { x: e.clientX, y: e.clientY };
      cursor.style.transform = "translate(" + (e.clientX - 24) + "px," + (e.clientY - 38) + "px) rotate(14deg)";
      cursor.classList.toggle("is-active", FINE_POINTER);
      if (immobile) return;
      brosse(e);
    });
  })();

  /* ──────────────────────────────────────────────
     6 bis. Avis : flèches de défilement
     ────────────────────────────────────────────── */
  (function reviewsNav() {
    var track = document.getElementById("reviewsTrack");
    var prev = document.getElementById("revPrev");
    var next = document.getElementById("revNext");
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector(".reviews__card");
      return card ? card.getBoundingClientRect().width + 24 : 320;
    }
    prev.addEventListener("click", function () { track.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { track.scrollBy({ left: step(), behavior: "smooth" }); });
  })();

  /* ──────────────────────────────────────────────
     7. Bouton d'achat (démo)
     ────────────────────────────────────────────── */
  var buyCta = document.getElementById("buyCta");
  var buyToast = document.getElementById("buyToast");
  var toastTimer = null;

  /* ──────────────────────────────────────────────
     8. Coloris (démo) + barre d'achat mobile
     ────────────────────────────────────────────── */
  var colorImg = document.getElementById("buyColorImg");
  document.querySelectorAll(".buy__color").forEach(function (b) {
    b.addEventListener("click", function () {
      if (colorImg) colorImg.src = b.getAttribute("data-img");
      document.querySelectorAll(".buy__color").forEach(function (o) {
        o.classList.remove("is-current");
        o.setAttribute("aria-checked", "false");
      });
      b.classList.add("is-current");
      b.setAttribute("aria-checked", "true");
    });
  });

  var stickyBar = document.getElementById("stickyBar");
  var buySection = document.getElementById("acheter");
  if (stickyBar && buySection) {
    var buyOnScreen = false;
    new IntersectionObserver(function (entries) {
      buyOnScreen = entries[0].isIntersecting;
      refreshSticky();
    }, { threshold: 0.15 }).observe(buySection);
    function refreshSticky() {
      var past = window.scrollY > window.innerHeight * 0.7;
      stickyBar.classList.toggle("is-visible", past && !buyOnScreen);
    }
    window.addEventListener("scroll", refreshSticky, { passive: true });
  }

  if (buyCta) {
    buyCta.addEventListener("click", function () {
      buyToast.classList.add("is-visible");
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        buyToast.classList.remove("is-visible");
      }, 3200);
    });
  }
})();
